import { useMutation, useQueryClient } from '@tanstack/react-query';

import { selectActiveAccount, useAuthStore } from '@features/auth';

import { updateClient } from '../api/clientsApi';
import type { UpdateClientRequest } from '../types';

export function useUpdateClient() {
  const queryClient = useQueryClient();
  const activeAccount = useAuthStore(selectActiveAccount);
  const accountId = activeAccount?.accountId ?? '';

  return useMutation({
    mutationFn: ({ clientId, request }: { clientId: string; request: UpdateClientRequest }) =>
      updateClient(accountId, clientId, request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['clients', accountId] });
    },
  });
}
